import { useCallback, useMemo } from 'react';
import { useUrlFilters } from '@/lib/hooks/useUrlFilters';
import type { ContractFilters } from '../types';

const defaults: ContractFilters = {
  id: undefined,
  limit: 50,
  page: 0,
  s: undefined,
  orderBy: 'createdAt',
  order: 'desc',
  status: undefined,
  type: undefined,
  clientId: undefined,
  createdById: undefined,
  practiceAreaId: undefined,
  periodId: undefined,
};

const numberFields: (keyof ContractFilters)[] = [
  'id', 'limit', 'page', 'clientId', 'createdById', 'practiceAreaId', 'periodId',
];

export function useContractFilters(initialFilters?: Partial<ContractFilters>) {
  const mergedDefaults = useMemo(
    () => ({ ...defaults, ...initialFilters }),
    [initialFilters]
  );

  const { updateFilter: baseUpdateFilter, ...rest } = useUrlFilters<ContractFilters>({
    defaults: mergedDefaults,
    numberFields,
  });

  // Auto-reset page when any filter other than page or limit changes
  const updateFilter = useCallback(
    <K extends keyof ContractFilters>(key: K, value: ContractFilters[K]) => {
      baseUpdateFilter(key, value, key !== 'page' && key !== 'limit');
    },
    [baseUpdateFilter]
  );

  return { ...rest, updateFilter };
}
